'use client';

// Re-export everything from @tracedocuments/api for backward compatibility.
export {
    ApiError,
    AuthSessionError,
    apiFetch,
    apiFetchWithTimeout,
    getApiBaseUrl,
    parseApiErrorResponse,
    publicApiFetch,
    setApiBaseUrl,
} from '@tracedocuments/api';
export type { ApiFetchInit } from '@tracedocuments/api';

